export default "__VITE_ASSET__PO78kcKN__"